import { CardListItem, StatusChip } from '@/design/components'
import { EMPTY, formatDate, formatDueLabel } from '@/lib/format'
import { SOURCE_LABEL, STATUS_LABEL, chipVariant } from '../status'
import type { Deadline } from '../types'

/** Siatka kolumn wiersza (mockup: DATA · TYTUŁ · SPRAWA · WŁAŚCICIEL · ŹRÓDŁO · STATUS). */
const GRID =
  'grid grid-cols-[112px_minmax(0,1fr)_190px_130px_104px_112px] items-center gap-4'

export function DeadlineRow({ deadline, onClick }: { deadline: Deadline; onClick?: () => void }) {
  return (
    <CardListItem onClick={onClick}>
      <div className={GRID}>
        <div className="leading-tight">
          <p className="font-semibold text-ink">{formatDate(deadline.due_date)}</p>
          <p className="mt-0.5 text-small text-muted">{formatDueLabel(deadline.due_date)}</p>
        </div>

        <div className="min-w-0 leading-tight">
          <p className="truncate font-semibold text-ink">{deadline.title}</p>
          {deadline.legal_basis ? (
            <p className="mt-0.5 truncate text-small text-muted">{deadline.legal_basis}</p>
          ) : null}
        </div>

        <div className="min-w-0 leading-tight">
          {deadline.case ? (
            <>
              <p className="t-mono truncate text-ink">{deadline.case.signature}</p>
              <p className="mt-0.5 truncate text-small text-muted">{deadline.case.client_name}</p>
            </>
          ) : (
            <>
              <p className="t-mono truncate text-danger">brak przypisania</p>
              <p className="mt-0.5 truncate text-small text-muted">wymaga dekretacji</p>
            </>
          )}
        </div>

        <span className="truncate text-ink">
          {deadline.owner ? (
            deadline.owner.short_name
          ) : (
            <span className="text-muted">nieprzypisany</span>
          )}
        </span>

        <span className="truncate text-small text-muted">
          {SOURCE_LABEL[deadline.source] ?? EMPTY}
        </span>

        <span className="flex justify-end">
          <StatusChip variant={chipVariant(deadline.status, deadline.due_date)}>
            {STATUS_LABEL[deadline.status]}
          </StatusChip>
        </span>
      </div>
    </CardListItem>
  )
}
